import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'

import MainLayout from './components/Layout/MainLayout'
import ProtectedRoute from './components/Layout/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import SKUManagement from './pages/SKU/SKUManagement'
import PackingManagement from './pages/Packing/PackingManagement'
import UserManagement from './pages/User/UserManagement'
import { useAuth } from './hooks'
import { LoadingSpinner, ErrorBoundary } from './components/common'

function App() {
  const { isAuthenticated, loading } = useAuth()

  // 如果正在初始化认证状态，显示加载页面
  if (loading) {
    return <LoadingSpinner tip="正在初始化..." />
  }

  return (
    <Router>
      <Routes>
        {/* 登录页面 */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <Login />
          } 
        />
        
        {/* 受保护的路由 */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* 仪表板 - 所有角色都可以访问 */}
          <Route index element={<Dashboard />} />
          
          {/* SKU管理 - 管理员和业务员可以访问 */}
          <Route 
            path="sku" 
            element={
              <ProtectedRoute requiredRole="BUSINESS">
                <SKUManagement />
              </ProtectedRoute>
            } 
          />
          
          {/* 装箱管理 - 管理员和业务员可以访问 */}
          <Route 
            path="packing" 
            element={
              <ProtectedRoute requiredRole="BUSINESS">
                <ErrorBoundary>
                  <PackingManagement />
                </ErrorBoundary>
              </ProtectedRoute>
            } 
          />
          
          {/* 用户管理 - 只有管理员可以访问 */}
          <Route 
            path="users" 
            element={
              <ProtectedRoute requiredRole="ADMIN">
                <UserManagement />
              </ProtectedRoute>
            } 
          />
        </Route>
        
        {/* 404页面 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default App